var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import { useLegoland } from "../LegolandContext";
import { useMeQuery } from "./authApiHooks";
/**
 * A hook that checks if the user is authenticated and has the required role(s).
 * If the user is not authenticated and `autoRedirect` is true, the user will be
 * redirected to the login page.
 */
export function useRequireAuth(_a) {
    var autoRedirect = _a.autoRedirect, role = _a.role;
    if (typeof role === "string") {
        role = [role];
    }
    var legolandUiUrl = useLegoland().legolandUiUrl;
    var _b = useMeQuery(), data = _b.data, error = _b.error, isError = _b.isError, isLoading = _b.isLoading, isSuccess = _b.isSuccess;
    useEffect(function onAuthStateChangeEffect() {
        if (autoRedirect && isSuccess && data.me === null) {
            window.location.assign("".concat(legolandUiUrl, "/login?redirect=").concat(encodeURIComponent(window.location.toString())));
        }
    }, [autoRedirect, isSuccess, data]);
    var queryStatus = { error: error, isError: isError, isLoading: isLoading, isSuccess: isSuccess };
    if (!isSuccess) {
        return __assign(__assign({}, queryStatus), { hasValidRole: undefined, isAuthenticated: undefined });
    }
    var isAuthenticated = Boolean(data.me);
    if (!isAuthenticated) {
        return __assign(__assign({}, queryStatus), { hasValidRole: undefined, isAuthenticated: isAuthenticated });
    }
    var hasValidRole = !role || role.includes(data.me.role);
    return __assign(__assign({}, queryStatus), { hasValidRole: hasValidRole, isAuthenticated: isAuthenticated });
}
/**
 * A component that checks if the user is authenticated and has the required
 * role(s). If the user is not authenticated and `autoRedirect` is true, the
 * user will be redirected to the login page. If the user does not have the
 * required role(s) or is not authenticated (if `autoRedirect` is false and no
 * role is provided), the `fallback` content will be rendered.
 */
export var RequireAuth = function (_a) {
    var _b = _a.autoRedirect, autoRedirect = _b === void 0 ? false : _b, children = _a.children, _c = _a.fallback, fallback = _c === void 0 ? null : _c, role = _a.role;
    var _d = useRequireAuth({
        autoRedirect: autoRedirect,
        role: role,
    }), hasValidRole = _d.hasValidRole, isAuthenticated = _d.isAuthenticated;
    if (isAuthenticated === undefined) {
        return null;
    }
    if (!isAuthenticated || !hasValidRole) {
        return React.createElement(React.Fragment, null, fallback);
    }
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=RequireAuth.js.map